import { IDefineCommand, IQuery } from 'core-ts-types';
import { ContactInformationModel } from '../models/contact_information_model';

angular
  .module('capability-ng-notification-settings')
  .factory(
    'loadContactInfoCommand',
    function loadContactInfoCommandDefinition(
      defineCommand: IDefineCommand,
      contactInformationModel: ContactInformationModel,
      $http: ng.IHttpService
    ) {
      return defineCommand('loadContactInfoCommand', function loadContactInfoCommand(deferred: any) {
        $http
          .get('notification/student/channels/')
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            contactInformationModel.initialize(data.channels);
            deferred.resolve(contactInformationModel);
          })
          .catch(() => {
            deferred.reject('failed to load data, please attempt again');
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/commands/load_contact_info_command.ts